import { get, del } from 'aws-amplify/api'
import { getCachedAuthSession } from 'services/authSessionCache'

import { monthFullName } from 'helpers/formatters'

import { ConversationResponse, GroupedConversations } from 'types/Chat'

class Chatbot {
  static async fetchConversations (token: string | undefined = undefined, dealerTier: string) {
    const session = await getCachedAuthSession()
    const idToken = session.tokens?.idToken?.toString()
    const rawUserId = session.tokens?.idToken?.payload['cognito:username']
    const userId = typeof rawUserId === 'string' ? rawUserId : null

    const queryParams: { limit: string; dealerTier: string; nextToken?: string } = { limit: '15', dealerTier }

    if (token) queryParams.nextToken = token

    const path = userId
      ? `/1/conversations?username=${encodeURIComponent(userId)}`
      : '/1/conversations'

    const restOperation = get({
      apiName: 'technicianBotApi',
      path,
      options: {
        headers: { Authorization: idToken ?? '' },
        queryParams
      }
    })

    const { body } = await restOperation.response
    const response = await body.json() as unknown as ConversationResponse

    const sorted = [...(response.conversations ?? [])].sort((a, b) => b.lastActivity - a.lastActivity)

    const grouped = sorted.reduce<GroupedConversations>((acc, conversation) => {
      const month = monthFullName(new Date(conversation.lastActivity))
      ;(acc[month] ??= []).push(conversation)
      return acc
    }, {})

    return { grouped, nextToken: response.nextToken ?? null, nbrRemainingMessages: response.nbrRemainingMessages }
  }

  static async getConversation (conversationId: string) {
    const s = await getCachedAuthSession()
    const idToken = s.tokens?.idToken?.toString()

    if (!idToken) return null

    const restOperation = get({
      apiName: 'technicianBotApi',
      path: `/1/conversations/${conversationId}`,
      options: {
        headers: { Authorization: idToken }
      }
    })

    const { body } = await restOperation.response
    return await body.json()
  }

  static async deleteConversation (conversationId: string) {
    const session = await getCachedAuthSession()
    const idToken = session.tokens?.idToken?.toString()

    if (!idToken) return null

    const restOperation = del({
      apiName: 'technicianBotApi',
      path: `/1/conversations/${conversationId}`,
      options: {
        headers: { Authorization: idToken }
      }
    })

    await restOperation.response
  }
}
export default Chatbot
